module.exports = __webpack_public_path__ + "img/Journalisma2.53ed07b3.png";